var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoy6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 1300,
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#BAC6A2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_226_2427",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1301,
    height: 1300
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#F7C0B5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_226_2427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1014 1197.33C1010.97 1199.5 1007.5 1201.66 1004.47 1203.83C1001 1206 997.967 1208.16 994.5 1209.9C991.467 1211.63 988.867 1213.36 985.834 1215.1C985.4 1215.53 984.967 1215.53 984.534 1215.96C974.567 1222.03 964.167 1227.66 953.767 1232.86C950.734 1234.6 947.267 1236.33 944.234 1237.63C944.234 1237.63 943.8 1238.06 943.367 1238.06C939.9 1239.8 936.434 1241.53 932.967 1243.26C926.034 1246.73 918.667 1249.76 911.734 1252.8C908.267 1254.53 904.367 1255.83 900.9 1257.13C897.434 1258.43 893.534 1260.16 890.067 1261.46C886.6 1262.76 882.7 1264.5 879.234 1265.8C879.234 1265.8 879.234 1265.8 878.8 1265.8C875.334 1267.1 871.434 1268.4 867.967 1269.7C860.167 1272.3 851.934 1274.9 844.134 1277.5C841.534 1278.36 838.5 1279.23 835.9 1280.1C827.667 1282.7 819.434 1284.86 811.2 1286.6C808.167 1287.46 805.134 1287.9 801.667 1288.76C793.867 1290.5 785.634 1292.23 777.834 1293.96C776.1 1294.4 774.8 1294.4 773.067 1294.83C770.467 1295.26 767.434 1295.7 764.834 1296.13C760.934 1296.56 757.467 1297.43 753.567 1297.86C751.834 1298.3 750.1 1298.3 748.367 1298.73C746.2 1299.16 743.6 1299.6 741 1299.6C734.067 1300.46 726.7 1301.33 719.767 1302.2C717.6 1302.63 715 1302.63 712.834 1303.06H712.4C709.367 1303.5 706.334 1303.5 703.3 1303.93C700.267 1304.36 697.234 1304.36 694.2 1304.36C692.467 1304.36 690.3 1304.8 688.567 1304.8C685.1 1304.8 682.067 1305.23 679.034 1305.23C674.7 1305.23 670.8 1305.66 666.467 1305.66C662.134 1305.66 658.234 1305.66 653.9 1305.66C650.867 1305.66 647.834 1305.66 644.8 1305.66C462.367 1303.06 297.7 1225.5 180.7 1102.43C180.7 1102.43 180.7 1102 180.267 1102C193.7 1075.56 243.534 1027.9 295.534 988.465C361.4 938.632 454.567 907.865 454.567 907.865C454.567 907.865 515.667 897.898 742.3 945.132C915.2 981.532 988.867 1129.3 1014 1197.33Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.401 1065.16C781.301 1109.8 722.367 1136.23 623.134 1096.36C501.367 1046.96 454.567 907.865 454.567 907.865C448.067 808.198 432.901 722.832 432.901 722.832C573.734 710.698 740.134 875.365 740.134 875.365L759.201 956.832C760.934 963.765 764.401 969.832 769.601 974.165C778.701 989.765 796.467 1036.56 790.401 1065.16Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.6 974.598C686.833 970.265 625.733 958.132 560.3 840.698C615.767 889.665 681.2 908.298 750.1 916.965L759.2 956.832C760.933 964.198 764.4 970.265 769.6 974.598Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.767 452.432C948.567 488.832 952.467 518.298 931.234 615.365C910 712.432 950.734 809.498 848.467 898.332C779.567 958.132 659.1 969.398 562.9 903.965C530.4 881.865 500.5 851.098 476.234 810.798C457.167 779.165 435.067 749.265 410.367 721.965C376.134 684.698 334.967 609.732 355.334 477.132C388.267 261.332 601.9 236.632 728 260.465C854.1 284.298 919.534 356.232 940.767 452.432Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.067 621.865C526.067 621.865 512.633 556.865 449.367 564.665C394.767 571.598 375.7 702.465 499.633 738.865",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.734 679.498C495.734 679.498 480.134 669.532 481.867 652.198C484.467 631.832 481.867 619.265 472.334 615.365C448.501 605.398 443.734 633.132 444.601 636.598",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.367 721.532C826.367 721.532 842.833 722.398 858.433 703.765C867.1 693.365 874.467 680.365 869.7 676.465C864.933 672.132 786.5 684.265 781.3 694.665C776.1 705.065 806.433 721.532 826.367 721.532Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.368 575.932C839.368 575.932 840.234 617.098 866.667 663.032C878.367 683.398 860.601 716.765 822.034 722.398",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M604.501 743.632C629.151 743.632 649.134 727.141 649.134 706.798C649.134 686.456 629.151 669.965 604.501 669.965C579.85 669.965 559.867 686.456 559.867 706.798C559.867 727.141 579.85 743.632 604.501 743.632Z",
    fill: "#ED938A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M924.3 670.832C923 695.098 923.434 718.932 921.7 742.765C902.634 738.432 888.767 724.132 888.767 707.232C888.767 689.032 903.934 674.298 924.3 670.832Z",
    fill: "#ED938A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.53 1467.78L68.8995 1443.51C57.6328 1167.05 171.166 1021.01 215.799 992.414C299.433 938.247 408.199 922.214 459.333 917.447C472.333 949.514 521.733 1054.81 624.433 1096.41C723.666 1136.71 782.599 1109.85 791.699 1065.21C797.333 1036.61 779.566 989.814 770.466 974.647C765.266 970.314 761.799 963.814 760.066 957.314L756.599 943.014C763.966 941.281 771.333 939.547 778.699 936.947C960.266 957.314 1033.93 1006.71 1077.27 1091.21C1121.9 1178.31 1166.53 1467.78 1166.53 1467.78Z",
    fill: "#474E51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.3 1466.05C261.3 1466.05 255.667 1325.65 250.033 1299.65",
    stroke: "#544D4D",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.17 1466.05C1029.17 1466.05 1016.17 1378.95 1016.17 1363.78C1016.17 1349.05 1027.43 1300.51 1029.17 1258.05",
    stroke: "#544D4D",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.533 1189.15L669.933 1512.41C669.933 1512.41 807.299 1606.01 807.299 1603.41C807.299 1600.81 872.299 1487.28 872.299 1487.28L770.899 1176.15C770.899 1176.15 757.899 1189.58 685.533 1189.15Z",
    fill: "#D85656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.732 1085.15C716.732 1085.15 657.366 1141.05 649.566 1155.78C641.766 1170.51 682.932 1193.91 682.932 1193.91C682.932 1193.91 749.232 1207.78 779.132 1180.91C779.132 1180.91 796.032 1162.28 792.566 1144.51C789.532 1127.18 716.732 1085.15 716.732 1085.15Z",
    fill: "#EA6363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.766 866.314L452.399 865.014C468.433 916.581 570.266 1038.35 716.733 1085.15L625.733 1199.98C619.666 1207.78 608.833 1209.08 601.033 1203.45C563.766 1175.71 464.099 1094.25 423.366 990.247C414.699 968.581 412.966 944.747 417.3 922.214L422.933 891.447C425.099 878.881 434.633 868.914 446.766 866.314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.066 1160.55C835.466 1174.85 818.566 1180.48 807.732 1170.51L716.299 1085.15C716.299 1085.15 769.599 1034.45 756.599 942.581C774.366 938.681 791.266 933.047 806.866 925.681C807.299 926.547 813.366 938.247 820.299 957.747C835.032 998.047 853.666 1072.15 838.066 1160.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.71 590.249C699.71 590.683 699.71 591.116 699.71 591.116L699.277 603.249C698.843 613.649 690.177 621.449 679.777 621.016C669.377 620.583 661.577 611.483 662.443 601.516L662.877 589.383C662.877 587.216 663.743 584.616 664.61 582.883L699.277 584.616C699.277 586.349 699.71 588.083 699.71 590.249Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.841 599.783L880.408 611.049C879.975 620.583 871.742 627.949 862.208 627.516C852.675 627.083 845.308 618.849 845.742 609.316L846.175 598.049C846.175 595.883 846.608 593.716 847.475 591.983L879.975 593.283C880.842 595.449 880.841 597.616 880.841 599.783Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.042 530.882C752.576 532.182 759.942 522.216 756.476 512.682C754.742 507.482 751.709 502.716 746.942 499.682C732.209 490.582 677.176 489.716 648.142 510.516C622.576 529.582 699.709 524.816 743.042 530.882Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.074 535.649C855.274 535.649 850.508 525.682 854.408 517.449C856.574 513.116 859.608 509.216 863.941 507.049C877.374 500.549 913.341 504.449 929.374 526.549C943.674 546.049 899.041 535.216 863.074 535.649Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.875 585.482L698.842 584.182L664.175 582.882L656.375 582.449",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.042 594.149L879.975 593.283L847.475 591.983H846.175",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.184 776.042C800.618 790.342 779.384 826.742 738.218 809.842C698.784 793.808 687.084 718.408 743.418 754.375C772.884 773.008 790.651 776.042 800.184 776.042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.417 774.308C808.417 774.308 790.217 784.275 743.417 754.375C687.517 718.408 698.784 793.808 738.217 809.842C779.384 826.742 800.617 789.908 800.184 776.042",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.284 765.208C705.284 765.208 734.751 784.709 743.418 782.975C752.518 781.675 751.217 794.242 792.384 795.542",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.439 442.654C939.139 436.154 937.405 429.221 935.238 422.721C933.072 416.221 927.872 410.588 920.939 409.288C898.405 405.388 876.738 366.387 845.538 362.054C746.305 348.621 680.005 356.854 586.839 393.254C490.639 430.521 545.239 585.654 524.872 609.488C521.405 597.354 504.505 547.954 449.039 554.887C396.605 561.387 376.672 682.721 485.005 724.321C484.139 748.154 441.239 770.687 406.572 729.087C371.905 687.487 302.572 579.587 349.372 421.854C396.172 264.121 608.072 181.788 805.239 261.954C839.039 275.821 859.405 310.054 888.872 315.688C1163.17 368.121 946.939 473.854 940.439 442.654Z",
    fill: "#E58600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.439 724.754C485.439 724.754 484.572 760.288 448.172 826.154C448.172 826.154 439.505 789.754 420.439 756.388C401.805 723.021 361.505 684.454 338.972 614.688C316.439 544.921 361.505 600.388 382.739 629.421C403.539 658.021 417.405 729.088 485.439 724.754Z",
    fill: "#E58600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.538 390.654C845.538 390.654 766.239 317.854 730.272 411.021C694.305 504.188 569.505 632.021 465.939 483.388C362.372 334.754 517.939 216.021 679.572 264.121C842.072 312.654 843.805 331.288 845.538 390.654Z",
    fill: "#E58600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.538 390.654C845.538 390.654 923.972 537.554 1007.17 472.121C1081.27 413.621 1066.54 275.821 953.438 243.754C849.438 214.287 838.172 268.021 734.172 210.821C630.172 153.621 441.672 191.754 406.572 325.654C406.572 325.654 305.172 361.188 301.272 483.821C297.372 606.454 393.572 713.054 393.572 713.054C393.572 713.054 336.372 503.321 444.272 472.121C552.172 440.921 582.072 333.021 653.572 333.021C725.072 333.021 800.038 324.354 845.538 390.654Z",
    fill: "#E58600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoy6);
export default __webpack_public_path__ + "static/media/Boy_6.21a8e1bcd37387c5b8e2ca38e82c3fcf.svg";
export { ForwardRef as ReactComponent };